import { Text } from '@chakra-ui/react';
import {
  GetIngestionDocumentFragment,
  IngestionDocumentValidationErrorReviewFragment,
  IngestionDocumentValidationFeedbackFragment,
} from '@client/graphql/__generated__/types';
import { FC } from 'react';
import { ComplianceValidationVariant } from '../ComplianceDrawer';
import { ValidationItem as ValidationItemType } from '../utils/validation.utils';
import { ValidationItemDiffData } from '../utils/validationItem.utils';
import { BaseValidationItem } from './BaseValidationItem';
import { EnhancedValidationTooltipContent } from './EnhancedValidationTooltipContent';

interface InternalValidationItemProps {
  item: ValidationItemType;
  variant: ComplianceValidationVariant;
  type: 'error' | 'success';
  rowKey: string;
  hoveredRowIndex: string | null;
  selectedDocument: GetIngestionDocumentFragment;
  allFeedback: IngestionDocumentValidationFeedbackFragment[];
  allHiddenReviews: IngestionDocumentValidationErrorReviewFragment[];
  diffData?: ValidationItemDiffData[];
  fieldsToImages?: Record<string, string>;
  onItemClick: (mappingKeys?: string[], contractDocumentUuid?: string) => void;
  onHideDocumentValidation?: (
    isHidden: boolean,
    message?: string,
    ingestionDocumentValidationId?: string,
    ruleUuid?: string,
    contractDocumentUuid?: string
  ) => void | Promise<void>;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const InternalValidationItem: FC<InternalValidationItemProps> = (
  props
) => {
  const { diffData, fieldsToImages, ...baseProps } = props;

  const hasDiffData = diffData && diffData.length > 0;

  // Check if this validation item is hidden
  const isHidden = props.allHiddenReviews.some(
    (review) =>
      review.ruleUuid === props.item.ruleUuid &&
      review.contractDocumentUuid === props.item.contractDocumentUuid &&
      review.isHidden
  );

  const subtitle = hasDiffData ? (
    <Text
      as="span"
      color={isHidden ? 'compliance.text.muted' : 'purple.500'}
      fontSize="sm"
      fontWeight="semibold"
      ml={1}
      textDecoration={isHidden ? 'line-through' : undefined}
      textTransform="uppercase"
    >
      (AI Corrected)
    </Text>
  ) : null;

  const enhancedTooltipContent = (
    <EnhancedValidationTooltipContent
      diffData={diffData}
      fieldImages={fieldsToImages}
      inputValues={props.item.inputValues}
      selectedDocument={props.selectedDocument}
      validationItem={props.item}
    />
  );

  return (
    <BaseValidationItem
      {...baseProps}
      subtitle={subtitle}
      tooltipContent={enhancedTooltipContent}
    />
  );
};
